<template>
    <div>
        <Documentos idSeccion="5"/>
    </div>
</template>

<script>
import Documentos from '@/components/Documentos'
import {mapState} from 'vuex'

export default {
    name: 'ReglamentoInstalaciones',
    props: {
    },
    data() {
        return {
            variable: ''
        }
    },
    created() {
    },
    components: {
        Documentos
    },
    computed: {
        ...mapState(['token'])
    },
}
</script>

<style scoped>

</style>